import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const CustomSelect = ({ labelId, label, value, onChange, options = [] }) => {
  return (
    <FormControl sx={{ minWidth: { xs: 150, sm: 200 }, height: { xs: '35px', sm: '52px' } }}>
      <InputLabel id={labelId} sx={{ fontSize: { xs: '0.7rem', sm: '0.9rem' }, lineHeight: '1' }}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value}
        label={label}
        onChange={onChange}
        sx={{ 
          fontSize: { xs: '0.7rem', sm: '0.9rem' },
          height: { xs: '35px', sm: '52px' },
          padding: '0 8px',
          '& .MuiSelect-select': {
            padding: '4px',
            lineHeight: '1.2',
          },
        }}
      >
        {Array.isArray(options) ? options.map((option) => (
          <MenuItem 
            key={option.value} 
            value={option.value} 
            sx={{ fontSize: { xs: '0.7rem', sm: '0.9rem' }, padding: '4px 8px', minHeight: '24px' }}
          >
            {option.label}
          </MenuItem>
        )) : <MenuItem disabled sx={{ fontSize: { xs: '0.7rem', sm: '0.9rem' }, padding: '4px 8px' }}>Brak opcji</MenuItem>}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;